export default function RowStyles({
  minHeight,
  justifyContent,
  flexGrow = 0,
  isRtl,
  margin,
  zIndex
}) {
  const { start, end } = defineStartAndEnd(isRtl);

  const expandedMargin = expandMargin(margin) || {};

  const row = () => {
    const totalMargin =
      (expandedMargin.marginStart || 0) + (expandedMargin.marginEnd || 0);

    return {
      zIndex,
      direction: isRtl ? 'rtl' : 'ltr',
      boxSizing: 'border-box',
      width: totalMargin ? `calc(100% - ${totalMargin}px)` : '100%',
      display: 'flex',
      flexWrap: 'wrap',
      flexShrink: 0,
      flexGrow,
      flexBasis: 'auto',
      alignItems: 'stretch',
      minHeight
    };
  };

  const rowJustifyContent = () => {
    switch (justifyContent) {
      case 'center':
        return { justifyContent: 'center' };
      case 'end':
        return { justifyContent: 'flex-end' };
      case 'flex-end':
        return { justifyContent: 'flex-end' };
      default:
        return { justifyContent: 'flex-start' };
    }
  };

  const rowMargin = () => {
    const { marginStart, marginEnd, marginTop, marginBottom } = expandedMargin;
    return {
      ...(marginStart
        ? {
            [`margin${start}`]: `${marginStart}px`
          }
        : {}),
      ...(marginEnd
        ? {
            [`margin${end}`]: `${marginEnd}px`
          }
        : {}),
      ...(marginTop ? { marginTop } : {}),
      ...(marginBottom ? { marginBottom } : {})
    };
  };

  return { ...row(), ...rowJustifyContent(), ...rowMargin() };
}

// helpers
function expandMargin(margin) {
  if (!!margin || margin === 0) {
    if (typeof margin === 'number') {
      return {
        marginEnd: margin,
        marginStart: margin
      };
    }
  }
  if (typeof margin === 'object' && margin !== null) {
    return {
      ...(margin.start ? { marginStart: margin.start } : {}),
      ...(margin.end ? { marginEnd: margin.end } : {}),
      ...(margin.top ? { marginTop: margin.top } : {}),
      ...(margin.bottom ? { marginBottom: margin.bottom } : {})
    };
  }
  return margin;
}

function defineStartAndEnd(isRtl) {
  return isRtl
    ? { start: 'Right', end: 'Left' }
    : { start: 'Left', end: 'Right' };
}
